export default "__VITE_ASSET__BQYLoOr$__"